"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ffApiNames = {
    internalApps: "internal_app_analytics"
};
exports.default = ffApiNames;
